
const awaitCallback = async (cb: any): Promise<any> => {
  return new Promise(async (resolve) => {
    resolve(cb);
  })
}
export default awaitCallback;
